/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {BaseCriteriaDtoModel as ɵf} from './lib/services';
export {BaseApiTemplateService as ɵd} from './lib/services/com-akaun-api/core2/api-services';
export {BaseGenDocTypeService as ɵc} from './lib/services/com-akaun-api/core2/api-services/erp';
export {BaseApiTemplateService as ɵa} from './lib/services/com-akaun-api/core2/api-services/shared';
export {BaseApiPublicLoginTemplateService as ɵb} from './lib/services/com-akaun-api/core2/api-services/shared/base-api-public-login-template.service';
export {BaseAuthCriteriaModel as ɵe} from './lib/services/com-akaun-api/core2/criteria/base-auth-criteria.model';